import request from "root/js/request";

export const getABCAnalyzeCrossMP = async ({
  cabinet_id,
  cabinet_id__in,
  marketplace,
  by,
  ...rest
}) => {
  const response = await request({
    url: "/analytics/cross-mp/abc_analyze/in_product/",
    method: "get",
    params: {
      cabinet_id,
      cabinet_id__in,
      marketplace,
      ...rest,
    },
  });
  return response.data;
};
